// extracted by mini-css-extract-plugin
module.exports = {"dark":"shelf__dark___voodo","light":"shelf__light___mafc5"};